import { createContext, useContext } from 'react';

export type ThemeColorSchemeType = 'light' | 'dark';

interface ThemeContextProps {
  darkMode: boolean;
  themeColorScheme: ThemeColorSchemeType;
  changeThemeColorScheme: (theme: ThemeColorSchemeType) => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  darkMode: false,
  themeColorScheme: 'light',
  changeThemeColorScheme: () => null,
});

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useTheme can only be used within ThemeProvider.tsx');
  }

  return context;
};
